module.exports = __webpack_public_path__ + "static/img/003.8fb78df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/003.png
// module id = 4Rip
// module chunks = 0